export const routes = [
  ...require('./service-tax/routes').routes
]
